
import { UnleashClient } from 'unleash-proxy-client';
import { UnleashProxyConfig } from './unleashProxy';

const config = UnleashProxyConfig;

const unleashClient = new UnleashClient(config);

unleashClient.start();

export const UnleashPlugin = {
  install(Vue) {
    Vue.prototype.$unleash = unleashClient;
  }
};
